export default __webpack_public_path__ + "resources/icons/d130-a34b.webp";